export default __webpack_public_path__ + "static/einmalig-live-international-a3801699e9ffa7e6f2d90c24350ca1ec.jpg";